export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 1a1 1 0 00-2 0v1H1.778c-.404 0-.837.108-1.19.392-.373.3-.588.743-.588 1.233v8.75c0 .49.215.933.587 1.233.354.284.787.392 1.19.392h12.445c.404 0 .837-.108 1.19-.392.373-.3.588-.743.588-1.233v-8.75c0-.49-.215-.933-.588-1.233-.354-.284-.786-.392-1.19-.392H13V1a1 1 0 10-2 0v1H5V1zM4 4h10v8H2V4h2zm-2.252.002h.002-.002zm0 7.996h.002-.002zm12.504 0h-.002.002zm0-7.996h-.002.002zM10.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};